import React from "react";
import styled from "styled-components";

const BubbleDiv = styled.div`
  border-radius: 50%;
  width: ${({ size }) => (size ? size : "10rem")};
  height: ${({ size }) => (size ? size : "10rem")};
  position: absolute;
  top: ${({ top }) => (top ? top : 0)};
  left: ${({ left }) => (left ? left : 0)};
  z-index: ${({ zIndex }) => (zIndex ? zIndex : -1)};
  ${({ bgType, bg }) =>
    bgType === "image"
      ? `background-image: url(${bg});
         background-size: cover;
         background-position: center;
        `
      : `background: ${bg};`}
  // overlay
  ${({ overlay }) =>
    overlay
      ? `.overlay {
          position: absolute;
          z-index: 10;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: ${overlay};
        }`
      : ""}
  // mobile styling
  ${({ mobBreak, mobSize, mobTop, mobLeft, mobOverlay, size, top, left }) =>
    mobBreak
      ? `@media only screen and (max-width: ${mobBreak}) {
          width: ${mobSize ? mobSize : size ? size : "10rem"};
          height: ${mobSize ? mobSize : size ? size : "10rem"};
          top: ${mobTop ? mobTop : top ? top : 0};
          left: ${mobLeft ? mobLeft : left ? left : 0};
          ${
            mobOverlay
              ? `.overlay {
                background: ${mobOverlay};
              }`
              : ""
          }
        }`
      : ""}
`;

const Bubble = ({
  size,
  top,
  left,
  bgType,
  bg,
  zIndex,
  overlay,
  mobBreak,
  mobSize,
  mobTop,
  mobLeft,
  mobOverlay,
}) => {
  return (
    <BubbleDiv
      size={size}
      top={top}
      left={left}
      bgType={bgType}
      bg={bg}
      zIndex={zIndex ? zIndex : 0}
      overlay={overlay}
      mobBreak={mobBreak}
      mobSize={mobSize}
      mobTop={mobTop}
      mobLeft={mobLeft}
      mobOverlay={mobOverlay}
    >
      <div className="overlay" />
    </BubbleDiv>
  );
};

export default Bubble;
